import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import BackButton from './BackButton';


class SubscriptionStatus extends Component {

  state = {
    isLoading: true,
    errorMessage: '',
    subscription: null,
    priceList: []
  };

  componentDidMount() {
    this.fetchData()
  }

  async fetchData() {
    const response = await this.props.subscriptionApi.getPlans()
    if (!response.ok) {
      this.setState({
          errorMessage: `Failed to fetch plans: ${response.status} ${response.statusText}`,
          isLoading: false
        }
      )
    } else {
      const jsonData = await response.json();
      this.setState({
        subscriptionPlans: jsonData,
        isLoading: false
      });
    }
  };

  createSubscription = async (priceId) => {
    const response = await this.props.subscriptionApi.createSubscription(priceId)
    if (!response.ok) {
      this.setState({
          errorMessage: `Failed to create subscription: ${response.status} ${response.statusText}`,
          isLoading: false
        }
      )
    } else {
      await this.props.resetSubscription();
      const jsonData = await response.json();
      this.setState({
        subscription: jsonData,
        isLoading: false
      });
    }
  };

  render() {
    const {errorMessage, isLoading, subscriptionPlans, subscription} = this.state;

    if (isLoading) {
      return (
        <div className="app">
          {this.props.navbar}
          <div className="page-container">
            <div className="loading-row"><span className="spinner"/> Loading...</div>
          </div>
        </div>
      );
    }

    if (subscription && subscription.clientSecret != null) {
      return <Redirect to={{
        pathname: '/paymentDetails',
        state: subscription
      }}/>
    } else if (subscription && subscription.clientSecret == null) {
      // this is a free plan. Redirect to Subscription status
      return <Redirect to={{pathname: '/subscriptionStatus'}}/>
    }

    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">Subscription</span>
          <h2 className="page-title">Choose a plan</h2>
          <p className="page-subtitle">Pick the plan that fits how often you need property records.</p>

          {errorMessage &&
            <div className="alert callout callout-warning">{errorMessage}</div>
          }

          <div className="pricing-grid">
            {subscriptionPlans.map((plan) => (
              <div className="pricing-card" key={plan.planId}>
                <div className="pricing-plan-name">{plan.planName}</div>
                <div className="pricing-plan-price">${plan.planPrice}<span> / month</span></div>
                <button className="btn-brand btn-brand-primary btn-block" onClick={() => this.createSubscription(plan.planId)}>
                  Select plan
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SubscriptionStatus);
